import { render, staticRenderFns } from "./PopupKaikas.vue?vue&type=template&id=549eec28&"
import script from "./PopupKaikas.vue?vue&type=script&lang=js&"
export * from "./PopupKaikas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports